import React from 'react';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    position: fixed;
    top: ${(props) => props.$topOffset};
    z-index: 1000;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: ${(props) => props.theme.DefaultBorder};
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 8px 22px rgba(55, 75, 90, 0.1);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);

    /* Nascondi i tabs inizialmente e mostrali dopo che il drawer è posizionato */
    visibility: hidden;
    animation: showTabs 0.3s ease-in-out 0.5s forwards;
    padding: 0.4rem max(0.35rem, env(safe-area-inset-right)) 0 max(0.35rem, env(safe-area-inset-left));

    .mobile-tab {
        position: relative;
        display: flex;
        flex: 1 1 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.2rem;
        min-width: 0;
        height: 3.35rem;
        margin: 0 0.12rem;
        padding: 0.35rem 0.1rem;
        border: 0;
        border-bottom: 3px solid transparent;
        color: ${(props) => props.theme.TextColorMuted};
        background: transparent;
        font: inherit;
        cursor: pointer;
        transition: color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
        -webkit-tap-highlight-color: transparent;

        svg {
            font-size: 1.25rem;
        }

        .mobile-tab-label {
            max-width: 100%;
            overflow: hidden;
            font-size: 0.58rem;
            font-weight: 600;
            line-height: 1;
            letter-spacing: 0.03em;
            text-overflow: ellipsis;
            text-transform: uppercase;
            white-space: nowrap;
        }

        &.active {
            border-bottom-color: ${(props) => props.theme.PrimaryColor};
            color: ${(props) => props.theme.PrimaryColor};
        }

        &:focus-visible {
            outline: 2px solid ${(props) => props.theme.PrimaryColor};
            outline-offset: 1px;
        }

        &:active {
            transform: scale(0.96);
        }

        & + .mobile-tab::before {
            position: absolute;
            top: 25%;
            bottom: 25%;
            left: -0.12rem;
            width: 1px;
            background: ${(props) => props.theme.BorderColor};
            content: '';
        }
    }

    @keyframes showTabs {
        from {
            visibility: hidden;
        }
        to {
            visibility: visible;
        }
    }
`;

const ModelDetailsMobileTabs = ({
    viewType,
    topOffset,
    onViewModelProfile,
    onViewCalendar,
    onViewModelBooks,
    onViewFiles,
    onViewComments,
    onViewAgencies,
}) => {
    const getActiveClassName = (view) => {
        if (view === viewType) return 'active';
        return '';
    };

    const getActiveIcon = (view, iconName) => {
        if (view === viewType) {
            switch (iconName) {
                case 'id-card':
                    return byPrefixAndName.fass['id-card'];
                case 'calendar':
                    return byPrefixAndName.fass['calendar'];
                case 'images':
                    return byPrefixAndName.fass['images'];
                case 'file-pdf':
                    return byPrefixAndName.fass['file-pdf'];
                case 'comments':
                    return byPrefixAndName.fass['comments'];
                case 'globe':
                    return byPrefixAndName.fass['globe'];
                // case 'balance-scale':
                //     return byPrefixAndName.fass['balance-scale'];
                default:
                    return '';
            }
        }
        switch (iconName) {
            case 'id-card':
                return byPrefixAndName.fasl['id-card'];
            case 'calendar':
                return byPrefixAndName.fasl['calendar'];
            case 'images':
                return byPrefixAndName.fasl['images'];
            case 'file-pdf':
                return byPrefixAndName.fasl['file-pdf'];
            case 'comments':
                return byPrefixAndName.fasl['comments'];
            case 'globe':
                return byPrefixAndName.fasl['globe'];
            // case 'balance-scale':
            //     return byPrefixAndName.fasl['balance-scale'];
            default:
                return '';
        }
    };

    return (
        <Wrapper $topOffset={topOffset}>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('profile')}`}
                aria-label="Profile"
                aria-pressed={viewType === 'profile'}
                onClick={onViewModelProfile}
            >
                <NwIcon icon={getActiveIcon('profile', 'id-card')} />
                <span className="mobile-tab-label">Profile</span>
            </button>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('calendar')}`}
                aria-label="Calendar"
                aria-pressed={viewType === 'calendar'}
                onClick={onViewCalendar}
            >
                <NwIcon icon={getActiveIcon('calendar', 'calendar')} />
                <span className="mobile-tab-label">Calendar</span>
            </button>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('books')}`}
                aria-label="Books"
                aria-pressed={viewType === 'books'}
                onClick={onViewModelBooks}
            >
                <NwIcon icon={getActiveIcon('books', 'images')} />
                <span className="mobile-tab-label">Books</span>
            </button>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('files')}`}
                aria-label="Files"
                aria-pressed={viewType === 'files'}
                onClick={onViewFiles}
            >
                <NwIcon icon={getActiveIcon('files', 'file-pdf')} />
                <span className="mobile-tab-label">Files</span>
            </button>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('comments')}`}
                aria-label="Comments"
                aria-pressed={viewType === 'comments'}
                onClick={onViewComments}
            >
                <NwIcon icon={getActiveIcon('comments', 'comments')} />
                <span className="mobile-tab-label">Comments</span>
            </button>
            <button
                type="button"
                className={`mobile-tab ${getActiveClassName('agencies')}`}
                aria-label="Agencies"
                aria-pressed={viewType === 'agencies'}
                onClick={onViewAgencies}
            >
                <NwIcon icon={getActiveIcon('agencies', 'globe')} />
                <span className="mobile-tab-label">Agencies</span>
            </button>
            {/* <NwIcon icon={getActiveIcon('statement', 'balance-scale')} className={getActiveClassName('statement')} pointer onClick={onViewStatement} /> */}
        </Wrapper>
    );
};

export default ModelDetailsMobileTabs;
